import { Button } from '@factorialco/deprecated-design-system'
import { EmployeeBlocksEmployeeFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import FormComponent from 'modules/core/components/Form'
import FormRow from 'modules/core/components/FormRow'
import PanesHeader from 'modules/core/components/PanesHeader'
import PanesPadForm from 'modules/core/components/PanesPadForm'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import { formGetDirtyFields } from 'modules/core/lib/formGetDirtyFields'
import i18n from 'modules/core/lib/i18n'

import {
  FormTypes,
  useEmployeePersonalProvider,
} from 'modules/employees/components/blocks/EmployeePersonalProvider'

import AddressInput from './AddressInput'

interface Props {
  employee: EmployeeBlocksEmployeeFragment
  readonly?: boolean
  isCurrent: boolean
}

export const EmployeeAddressBlock = observer((props: Props) => {
  const { employee, readonly } = props
  const {
    addressForm,
    onSubmit: onSubmitAddress,
    disableSectionSaveButtons,
  } = useEmployeePersonalProvider()

  const onSubmit = () => {
    onSubmitAddress([FormTypes.ADDRESS])
    track(trackingEvents.employee.editEmployeeInformationSubmit, {
      fields_edited: formGetDirtyFields(addressForm),
      legal_entity_country: employee.legalEntity?.country,
      layout_version: 'v1',
    })
  }

  return (
    <FormComponent onSubmit={onSubmit}>
      <FormRow>
        <AddressInput mandatory form={addressForm} readonly={readonly} showCues />
      </FormRow>
      {!disableSectionSaveButtons && addressForm.isDirty && (
        <FormRow footer>
          <Button submit>{i18n.t('common.submit')}</Button>
        </FormRow>
      )}
    </FormComponent>
  )
})

const EmployeeAddress = (props: Props) => {
  return (
    <PanesPadForm direction="horizontal" boxed>
      <PanesHeader
        illustration="sign-post"
        title={i18n.t('employee_form.address.title')}
        description={i18n.tCurrent('employee_form.address.description', props.isCurrent)}
      />
      <EmployeeAddressBlock {...props} />
    </PanesPadForm>
  )
}

export default observer(EmployeeAddress)
